<template>
  <div>
    <!-- query field -->
    <v-row no-gutters>
      <v-switch
        v-model="conditionValue.hasQuery"
        class="mx-3"
        label="Requête"
        color="success"
        hide-details
        :disabled="isDisabled"
      />
    </v-row>

    <!-- Select of the options of a query (anchoring) and field of condition pattern-->
    <v-row v-if="conditionValue.hasQuery" no-gutters>
      <v-col class="mx-3" cols="4">
        <v-select
          v-if="conditionValue.hasQuery"
          v-model="conditionValue.anchoring"
          item-text="name"
          item-value="value"
          item-color="info"
          menu-props="light"
          :rules="[(v) => !!v || 'Required']"
          :items="queryOptions"
          color="blue"
          hide-details
          @change="changeAnchoring"
        />
      </v-col>
      <v-col cols="6" class="mx-2">
        <v-combobox
          v-model="conditionValue.pattern"
          label="Entrer une requête de recherche"
          autocomplete="off"
          multiple
          item-color="info"
          menu-props="light"
          color="blue"
          clearable
          deletable-chips
          :rules="[queryRule]"
          chips
          small-chips
          hide-details
          @change="removeEmptyInput"
        >
          <template #append-outer>
            <v-btn icon @click="openCopyPastePopup">
              <v-icon>mdi-clipboard-text-multiple</v-icon>
            </v-btn>
          </template>
        </v-combobox>
        <v-col cols="6" class="mx-2" />
      </v-col>
      <v-row class="mx-3">
        <v-checkbox
          v-model="conditionValue.alternatives"
          label="Appliquer aux pluriels, aux synonymes et fautes de frappe"
          color="success"
          :disabled="pluralCheckboxDisabled"
        />
      </v-row>
    </v-row>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';
import { EventBus } from '../../../../../mixins';

const tempFix = value => {
  // PATTERN is an array of words now it used to be a string
  if (value.pattern && !Array.isArray(value.pattern)) {
    value.pattern = [value.pattern];
  }
  return value;
};

const props = defineProps({
  condition: { type: Object, default: null },
  isDisabled: { type: Boolean, default: false }
});

const conditionValue = ref(tempFix(props.condition));

const queryOptions = ref([
  { name: 'Contient', value: 'contains' },
  { name: 'Est', value: 'is' },
  { name: 'Commence par', value: 'startsWith' },
  { name: 'Termine par', value: 'endsWith' }
]);
const pluralCheckboxDisabled = ref(false);

const queryRule = computed(() => {
  let rule = true;

  if (
    conditionValue.value
    && (!conditionValue.value.pattern
      || (conditionValue.value.pattern
        && conditionValue.value.pattern.length < 1))
  ) {
    rule = 'Required';
  }

  if (conditionValue.value.anchoring === 'is') {
    rule = true;
  }

  return rule;
});

const copyPasteValues = pasteValues => {
  pasteValues.forEach(pasteValue => {
    if (!conditionValue.value.pattern.includes(pasteValue.value)) {
      conditionValue.value.pattern.push(pasteValue.value);
    }
  });
};

const openCopyPastePopup = () => {
  EventBus.$on('copyPasteValues', copyPasteValues);
  EventBus.$emit('showCopyPastePopup');
};

const changeAnchoring = value => {
  if (value === 'is' && (!conditionValue.value.pattern || (conditionValue.value.pattern && !conditionValue.value.pattern.length))) {
    pluralCheckboxDisabled.value = true;
    conditionValue.value.alternatives = false;
  } else {
    pluralCheckboxDisabled.value = false;
  }
};

const disablePluralsCheckbox = () => {
  if (conditionValue.value.pattern && conditionValue.value.pattern.length) {
    pluralCheckboxDisabled.value = false;
  } else if (conditionValue.value.anchoring === 'is') {
    pluralCheckboxDisabled.value = true;
    conditionValue.value.alternatives = false;
  } else {
    pluralCheckboxDisabled.value = false;
  }
};

const removeEmptyInput = values => {
  conditionValue.value.pattern = values.filter(v => v.trim() !== '');
  disablePluralsCheckbox();
};

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:condition']);

watch(conditionValue.value, val => {
  // Updates v-model on the parent
  emit('update:condition', val);
}, { deep: true });

onMounted(() => {
  conditionValue.value.anchoring = conditionValue.value.anchoring || 'contains';
  changeAnchoring(conditionValue.value.anchoring);
});
</script>

<style>
</style>
